module.exports = __webpack_public_path__ + "static/media/share.7e8699c0.svg";